import { styled, css, Link } from '@mui/material';

export const StyledHeader = styled('header')(
  ({ theme }) => css`
    position: relative;
    width: 100%;
    height: ${theme.shape.headerDesktop};
    z-index: 1000;
  `
);

export const StyledHeaderSticky = styled('div')(
  ({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${theme.shape.headerDesktop};
    background-color: ${theme.palette.common.white};
    box-shadow: ${theme.shadows[2]};
    z-index: 99;
  `
);

export const StyledHeaderContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 ${theme.spacing('LARGE')};
    margin: 0 auto;

    ${theme.breakpoints.up('desktop')} {
      max-width: ${theme.shape.headerMaxWidth};
      padding: 0;
    }
  `
);

export const StyledHeaderLogoLinks = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    column-gap: ${theme.spacing('1XL')};

    img {
      transition: all 0.3s;
    }
  `
);

export const StyledCompanyLogoButton = styled(Link)`
  display: flex;
  align-items: center;
  opacity: 1;
  transition: 0.6s opacity 0.2s ease-out;

  > img {
    width: auto;
    height: 2rem;
  }
`;

export const StyledDaDirektLogo = styled('img')`
  width: 5rem;
  height: auto;
`;

export const StyledHeaderBurgerMenu = styled('div')(
  ({ theme }) => css`
    position: relative;
    z-index: 99;
    cursor: pointer;

    ${theme.breakpoints.up('desktop')} {
      display: none;
    }
  `
);

export const StyledMaintenanceBanner = styled('div')(
  ({ theme }) => css`
    background: ${theme.palette.main.product_blue};
    padding: ${theme.spacing('LARGE')};
  `
);

export const StyledMaintenanceBannerContent = styled('div')(
  ({ theme }) => css`
    margin: 0 auto;
    max-width: ${theme.shape.container};
  `
);
